import React from "react";
import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import { modalStyleWide } from "../modal-style-wide";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { useLyricsModal } from "../../hooks/useLyricsModal";
import { format } from "../../components/text-helper/text-helper";

const LyricsModal = () => {
    const { lyricsModalOpen, artist, track, lyrics, setLyricsModalOpen, errorOccurred } = useLyricsModal();

    return (
        <Modal open={lyricsModalOpen}>
            <Box sx={{ ...modalStyleWide, overflow: "hidden", display: "flex", flexDirection: "column" }}>
                <Stack spacing={1} direction="column" sx={{ height: "100%", minHeight: 0 }}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        {format(artist ?? "")} - {track}
                    </Typography>
                    {errorOccurred && (
                        <Typography id="modal-modal-error" variant="body2" color="error">
                            Unable to fetch lyrics.
                        </Typography>
                    )}
                    <Box sx={{ overflowY: "auto", flex: 1, minHeight: 300 }}>
                        <Typography id="modal-modal-lyrics" variant="body1" component="pre">
                            {lyrics}
                        </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between" sx={{ flexShrink: 0 }}>
                        <Button variant="contained" size="small" onClick={() => setLyricsModalOpen(false)} color="primary">
                            <FontAwesomeIcon fontSize="large" icon={faClose} className="icon" />
                            Close
                        </Button>
                    </Box>
                </Stack>
            </Box>
        </Modal>
    );
}

export default LyricsModal;